import { render, staticRenderFns } from "./HomeSuperadmin.vue?vue&type=template&id=9e31a342&"
import script from "./HomeSuperadmin.vue?vue&type=script&lang=js&"
export * from "./HomeSuperadmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports